import PropTypes from 'prop-types';
import { LegType } from './LegType';

export const SegmentType = Object.freeze({
    DEPARTURE: LegType.DEPARTURE,
    ARRIVAL: LegType.ARRIVAL,
    DATE: 'DATE',
});

export const SegmentTypeProps = PropTypes.oneOf(Object.values(SegmentType));
